// eslint-disable-next-line no-restricted-imports
import { App, Modal } from "antd"
import { useCallback, useState } from "react"
import { ExpectAiSurveyModalConfig } from "src/global/ui/Surveys/ExpectAiApprovalSurveyModal"
import { getLocalStorageItem, setLocalStorageItem } from "src/global/utils/localStorage"

export const LOCAL_STORAGE_KEY = "expectAiApprovalSurveyDismissed"

export function useExpectAiSurveyModal(): { openModalAfterDelay: () => (() => void) | undefined } {
  const { modal } = App.useApp()
  const [previouslyDismissed, setPreviouslyDismissed] = useState(getLocalStorageItem(LOCAL_STORAGE_KEY))

  const openModalAfterDelay = useCallback(() => {
    if (previouslyDismissed) return undefined

    const handleClose = () => {
      const now = new Date().toISOString()
      setLocalStorageItem(LOCAL_STORAGE_KEY, now)
      setPreviouslyDismissed(now)
      Modal.destroyAll()
    }

    const timer = setTimeout(() => {
      modal.info({
        ...ExpectAiSurveyModalConfig(handleClose),
        onCancel: handleClose,
      })
    }, 3000)

    return () => clearTimeout(timer)
  }, [modal, previouslyDismissed])

  return { openModalAfterDelay }
}
